import React, { Fragment, useContext, useEffect, useMemo, useState } from "react";
import {
  Grid,
  GridColumn,
  GridColumnMenuWrapper,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import Button from "@mui/material/Button";

import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardActionArea,
  Typography,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import visileColumns from "./visibleColumns";
import { orderBy } from "@progress/kendo-data-query";
import AdvanceSearch from "../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../ErrorBoundry";
import { Link, useNavigate } from "react-router-dom";
import {
  faClock,
  faDiagramProject,
  faEye,
  faList,
  faUserCheck,
} from "@fortawesome/pro-duotone-svg-icons";
import { filterAllowedColumn, isAllowedURL } from "../../_helper/helper";
import { useAuth } from "oidc-react";
import { Btn } from "../../AbstractElements";
import { Icon } from "@progress/kendo-react-common";
import PeContext from "../../_helper/Customizer"
import "../Backbutton/backbutton.css"
import { Tooltip } from "@progress/kendo-react-tooltip";
import TelerikDataTable from "../../CommonComponents/TelerikDataTable";
function PerformanceEvalutionList() {
  let {
    columns,
    loadingSearch,
    searchParameter,
    searchResults,
    ColumnsSorted,
    searchResultsV2,
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const history = useNavigate();
  const { userData } = useAuth();
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [searchParams, setSearchParams] = useState([]);
  const [sortedColumns, setSortedColumns] = useState(visileColumns);
  const { toggleIcon, toggleSidebar } = useContext(PeContext);

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };
  const id = "performanchEvalution";
  const HRAdmin = "HRAdmin";
  const supervisor = "supervisor";
  const Authority = "appointingAuthority";
  const reviewer = "reviewer";
  const employee = "user";
  const { results, rowCount } =
    searchResultsV2[id] == undefined
      ? { results: [] }
      : searchResultsV2[id] || {};

  const actions = useMemo(() => {
    return [
      {
        title: "Show Details",
        action: (props) => {
          return history(
            `/performance-evaluation/${props.dataItem.EmployeeID}/${props.dataItem.ID}`,
            { state: columns }
          );
        },
        icon: { iconName: "k-icon  k-i-eye" },
        className: "font-primary",
        style: { cursor: "pointer" },
      },
      // {
      //   title: "Employee's All Transactions ",
      //   action: (props) => {
      //     return history(`/transaction-log/${props.dataItem.EmployeeID}`);
      //   },
      //   icon: { iconName: "k-icon  k-i-list-bulleted" },
      //   className: "font-primary",
      //   style: { cursor: "pointer" },
      // },
      // {
      //   title: "Workflow",
      //   actionType: "workflow",
      //   className: "font-primary",
      //   icon: { iconName: "k-icon  k-i-dictionary-add" },
      //   style: { cursor: "pointer" },
      //   onlyVisible: "workflowID",
      // },
      // {
      //   title: "Work Plan",
      //   action: (props) => {
      //     return history(
      //       `/work-planning/${props.dataItem.EmployeeID}/${props.dataItem.ID}`,
      //       { state: columns }
      //     );
      //   },
      //   icon: faClock,
      //   className: "font-primary",
      //   style: { cursor: "pointer" },
      // },
      // {
      //   title: "Individual Development",
      //   action: (props) => {
      //     return history(
      //       `/individual-development-plan/${props.dataItem.EmployeeID}/${props.dataItem.ID}`,
      //       { state: columns }
      //     );
      //   },
      //   icon: faUserCheck,
      //   className: "font-primary",
      //   style: { cursor: "pointer" },
      // },
    ];
  });
  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);

  useEffect(() => {
    if (ColumnsSorted[id] !== undefined) {
      setSortedColumns(ColumnsSorted[id]);
    } else {
      if (columns && visileColumns.length > 0 && columns.length > 0) {
        const clms = visileColumns.map((d) => d.field.toLowerCase());
        const data = columns
          .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
          .map((p) => {
            return {
              field: p.column_name,
              show: false,
              locked: false,
              width: 200,
              title: p.column_title,
              filter: "text",
            };
          });
        setSortedColumns(
          filterAllowedColumn(userData, visileColumns.concat(data)),
          "employeeID"
        );
      }
    }
  }, [columns]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  const getWhere = () => {
    if (userData.profile.role === "user") {
      return `employeeID = ${userData?.profile?.EmployeeID} and HrControl is not null   ${additionalWhere ? `and ${additionalWhere}` : ``
        }`;
    } else {
      return additionalWhere;
    }
  };
  useEffect(() => {
    if (searchParameter[id]?.searchParams?.length > 0) {
      setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
    }
  }, [searchParameter]);

  const array = [
    {
      name: "Outstanding (Explain)",
      value: 1,
    },

    {
      name: "Satisfactory",
      value: 2,
    },

    {
      name: "Unsatisfactory (Explain)",
      value: 3,
    },

    { name: "High Satisfactory (Explain)", value: 4 },

    { name: "Marginal (Explain)", value: 5 },
  ];

  return (
    <ErrorBoundary>
      {" "}
      <Fragment>
        <Row className="bg-primary py-2 mb-2">
          <Typography variant="h5"
            style={{ display: "flex", alignItems: "center" }}
          >
            {/* <div> */}
            {/* <Icon style={{ fontSize: '25px', margin:"10px"}} name="file-ascx" /> */}
            {!toggleIcon ? (
              <Icon
                size="medium"
                style={{
                  fontSize: "25px",
                  margin: "10px",
                }}
                name="graph"
              />
            ) : (
              <Tooltip
                anchorElement="target"
                position="top"
                style={{ marginLeft: "10px" }}
              >
                <Btn
                  attrBtn={{
                    color: "primary",
                    onClick: () => {
                      openCloseSidebar();
                    },
                    className: "custom-back-button",
                    title: "Back to Menu",
                    style: {
                      fontSize: "18px",
                      outline: "1px solid white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "4px 8px",
                      paddingRight: "10px",
                      // fontSize: '1rem',
                      cursor: "pointer",
                      marginRight: "6px",
                    },
                  }}
                >
                  <Icon
                    size="medium"
                    style={{
                      fontSize: "25px",
                      marginRight: "5px",
                      // cursor:"pointer",
                    }}
                    name="arrow-left"
                    onClick={openCloseSidebar}
                  />
                  Back
                </Btn>
              </Tooltip>
            )}
            {/* <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" /> */}
            Performance Evaluation
            {/* </div> */}
            <div className="f-right">
              {[HRAdmin, supervisor].includes(userData.profile.role) ? (
                <Button
                  variant="outlined"
                  className="mx-2 bg-white"
                  color="primary"
                >
                  <Link to={`${process.env.PUBLIC_URL}/employee-master`}>
                    <Typography className="text-12">
                      <i
                        class="fa-duotone fa-users m-r-10"
                        style={{ color: "#1569C7", marginRight: "10px" }}
                      ></i>
                      View Employee Master
                    </Typography>
                  </Link>
                </Button>
              ) : undefined}
            </div>
          </Typography>
        </Row>
        <Container fluid={true}>
          <Row>
            <Col sm="12" className="page-content">
              <Card>
                <CardBody>
                  <AdvanceSearch
                    id={id}
                    gridId={id}
                    location="global"
                    columnList={"*"}
                    columnRefernces={[]}
                    tableName={"Performance-Evaluation"}
                    searchParams={searchParams}
                    additionalWhere={getWhere()}
                    expanded={true}
                    sortData={sortData}
                    pageNumber={page}
                    pageSize={pageSize}
                    chooseFilterMethod={chooseFilterMethod}
                  />

                  <div>
                    {/* {sortedColumns.length > 0 && ( */}
                    <TelerikDataTable
                      id={id}
                      pageSize={pageSize}
                      totalCount={rowCount}
                      skip={(page - 1) * pageSize}
                      take={pageSize}
                      data={results || []}
                      sortData={sortData}
                      pageNumber={page}
                      tableName={"Performance-Evaluation"}
                      searchParams={searchParams}
                      additionalWhere={getWhere()}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      selectedColumns={sortedColumns}
                      setSortedColumns={setSortedColumns}
                      loading={loadingSearch}
                      actions={actions}
                      // isDashboard={true}
                      // setChooseFilterMethod={setChooseFilterMethod}
                      chooseFilterMethod={chooseFilterMethod}
                    ></TelerikDataTable>
                    {/* )} */}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    </ErrorBoundary>
  );
}
export default PerformanceEvalutionList;
